import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { readSmsSignInEnabled, sendPhoneSignInCode, verifyPhoneSignInCode } from "@/lib/sms-sign-in";

export const PhoneOtpForm = () => {
  const { t } = useTranslation();
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const enabled = useQuery({
    queryKey: ["feature-flag", "sms_sign_in"],
    queryFn: readSmsSignInEnabled,
    staleTime: 30_000,
  });

  if (!enabled.data) return null;

  const send = async () => {
    const { error } = await sendPhoneSignInCode(phone);
    if (error) {
      toast.error(error.message || t("modules.batchA.smsOff"));
      return;
    }
    setSent(true);
    toast.success(t("modules.batchA.saved"));
  };

  const verify = async () => {
    const { error } = await verifyPhoneSignInCode(phone, code);
    if (error) {
      toast.error(error.message || t("modules.batchA.smsOff"));
      return;
    }
    toast.success(t("modules.batchA.saved"));
  };

  return (
    <div className="space-y-2 rounded-md border p-3">
      <p className="text-sm font-medium">{t("modules.batchA.phoneTitle")}</p>
      <p className="text-xs text-muted-foreground">{t("modules.batchA.phoneBody")}</p>
      <Input value={phone} onChange={(event) => setPhone(event.target.value)} placeholder="+60" />
      {sent && <Input value={code} onChange={(event) => setCode(event.target.value)} placeholder="123456" />}
      <div className="flex gap-2">
        <Button type="button" variant="outline" onClick={send}>{t("modules.batchA.sendCode")}</Button>
        {sent && <Button type="button" onClick={verify}>{t("modules.batchA.verifyCode")}</Button>}
      </div>
    </div>
  );
};
